// removed by extract-text-webpack-plugin
module.exports = {"white":"white__eI1OC","label":"label__1rXO-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/RoadTestView/coms/CoverageModal/styles.scss
// module id = 2300
// module chunks = 1